// global Vue event bus for $emit-ing events to component listeners ($on)

export var eventBus = require('tiny-emitter/instance');

// export default {
//   $on: (...args) => emitter.on(...args),
//   $once: (...args) => emitter.once(...args),
//   $off: (...args) => emitter.off(...args),
//   $emit: (...args) => emitter.emit(...args)
// }